/**
 * Where background tasks will show their progress in the sidebar (`StepProgress`). No job API
 * exists yet, so it renders nothing rather than invented tasks; the job API's change feeds it.
 */
export function TasksSlot() {
  return null;
}
